export const IMAGE_UPLOAD_MAX_MB = 10;
export const IMAGE_UPLOAD_MAX_BYTES = IMAGE_UPLOAD_MAX_MB * 1024 * 1024;
